// extracted by mini-css-extract-plugin
export default {"tabsLayout":"styles_tabs-layout__wATWN","tabsLayout__toolbar":"styles_tabs-layout__toolbar__xrzXi","tabsLayout__tabs":"styles_tabs-layout__tabs__2OzSw"};